import { render, staticRenderFns } from "./size-expand.vue?vue&type=template&id=0e6f269e&scoped=true&"
import script from "./size-expand.vue?vue&type=script&lang=js&"
export * from "./size-expand.vue?vue&type=script&lang=js&"
import style1 from "./size-expand.vue?vue&type=style&index=1&id=0e6f269e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6f269e",
  null
  
)

export default component.exports